/**
 * Đọc/ghi `localStorage` an toàn cho các công tắc phải NHỚ qua lần tải (port `ghi-nho.ts` native). Chế độ riêng tư của
 * Safari ném NGAY Ở LƯỢT ĐỌC, nên cả hai chiều đều bọc — mất phần ghi nhớ, KHÔNG được mất tính năng.
 */
export function nho(khoa: string, macDinh = ''): string {
  try {
    return localStorage.getItem(khoa) ?? macDinh;
  } catch {
    return macDinh;
  }
}

export function ghiNho(khoa: string, giaTri: string): void {
  try {
    localStorage.setItem(khoa, giaTri);
  } catch {
    // Chế độ riêng tư chặn ghi.
  }
}

/**
 * Đọc một DANH SÁCH, kèm đường nâng cấp từ giá trị một-chuỗi của khoá cũ. KHÔNG BAO GIỜ ghi ngược vào khoá cũ: một tab
 * bản cũ đọc `["a","b"]` như một mã nguồn sẽ nhận 404 cho mọi lời gọi.
 */
export function nhoDs(khoa: string, khoaCu = ''): string[] {
  try {
    const raw = localStorage.getItem(khoa);
    if (raw) {
      const v: unknown = JSON.parse(raw);
      // Lọc kỹ chứ không tin: `localStorage` là thứ người dùng sửa được.
      if (Array.isArray(v)) return v.filter((x): x is string => typeof x === 'string' && !!x);
    }
    const cu = khoaCu ? localStorage.getItem(khoaCu) : null;
    return cu ? [cu] : [];
  } catch {
    return [];
  }
}

export function ghiNhoDs(khoa: string, ds: string[]): void {
  try {
    localStorage.setItem(khoa, JSON.stringify(ds));
  } catch {
    // Như trên.
  }
}
